<script>
import { mapState, mapActions } from "vuex";

import dateMixin from "@/mixins/dateMixin";
import numberMixin from "@/mixins/numberMixin";
import transferMixin from "@/mixins/transferMixin";

import ProfileRow from "@/components/_Shared/Users/Profile/Row";
import DataTableTitle from "@/components/_Shared/DataTable/Title";

export default {
  mixins: [numberMixin, dateMixin, transferMixin],

  data() {
    return {
      expanded: []
    };
  },

  components: {
    ProfileRow,
    DataTableTitle
  },

  props: {
    professional: {
      type: [Object, Boolean],
      required: false,
      default: false
    },
    channelType: {
      type: String,
      required: false,
      default: ""
    }
  },

  computed: {
    ...mapState("transfersList", [
      "headers",
      "items",
      "totalItems",
      "options",
      "search",
      "loader",
      "footerProps"
    ]),
    options: {
      get() {
        return this.$store.state.transfersList.options;
      },
      set(value) {
        this.$store.dispatch("transfersList/setOptions", value);
      }
    }
  },

  methods: {
    ...mapActions("transfersList", [
      "getItems",
      "setSearch",
      "setProfessional",
      "setChannelType"
    ]),

    submitSearch(text) {
      try {
        this.setSearch(text);
      } catch (e) {
        this.$toast.error(e);
      }
    },

    iconType(type) {
      return type === "bank_accounts"
        ? "account_balance"
        : "account_balance_wallet";
    }
  },

  watch: {
    options: {
      handler() {
        this.getItems();
      },
      deep: true
    }
  },

  mounted() {
    this.setProfessional(this.professional);
    this.setChannelType(this.channelType);
  }
};
</script>

<template>
  <v-card class="mb-20 px-4" flat>
    <data-table-title
      icon="swap_horiz"
      title="Transferências"
      :search="search"
      @search="submitSearch($event)"
    />

    <v-divider></v-divider>

    <v-layout column>
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :footer-props="footerProps"
        :loading="loader"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:item.type="{ item }">
          <v-icon size="30" color="primary">
            {{
              item.channel != undefined ? iconType(item.channel.type) : "help"
            }}
          </v-icon>
        </template>

        <template v-slot:item.created_at="{ item }">
          <v-chip small outlined>{{ item.created_at | dateAndTime }}</v-chip>
        </template>

        <template v-slot:item.from="{ item }">
          <profile-row :account="item.payment_gateway_account.account" />
        </template>

        <template v-slot:item.to="{ item }">
          <profile-row
            v-if="item.channel != undefined"
            :account="item.channel.payment_gateway_account.account"
          />
        </template>

        <template v-slot:item.status="{ item }">
          <v-chip small :color="item.status | getTransferStatus('color')">
            {{ item.status | getTransferStatus("name") }}
          </v-chip>
        </template>

        <template v-slot:item.amount="{ item }">
          <v-chip small>{{ item.amount | intToCurrency }}</v-chip>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <p class="mt-5">
              <b>DESCRIÇÃO:</b>
              {{ item.description }}
            </p>
            <p>
              <b>WIRECARD_ID:</b>
              {{ item.payment_gateway_id }}
            </p>
          </td>
        </template>
      </v-data-table>
    </v-layout>
  </v-card>
</template>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/Transfers/List.vue